import { Component } from '@angular/core';

/** Coquille hôte : barre de titre (vente) + liste clients bibliothèque. */
@Component({
  selector: 'app-clients-list-shell',
  template: '<app-title-section></app-title-section><router-outlet></router-outlet>'
})
export class ClientsListShellComponent {}
